module.exports = __webpack_public_path__ + "assets/img/8.86d18120.png";